
/**
 * Constants
 */
export default class Constants {

    /**
     * Delays preloader for testing
     *
     * @type {Boolean}
     */
    public static DEMO_MODE: boolean = true;

    /**
     * If we should use an animating background or not
     *
     * @type {Boolean}
     */
    public static ANIMATE_BACKGROUND: boolean = true;

    /**
     * Standard animation time for zooming to floors
     *
     * @type {Number}
     */
    public static ANIMATION_TIME: number = 700;

    /**
     * Enables/Disables Preloader
     *
     * @type {Number}
     */
    public static ALLOW_LOADING: boolean = true;

    /**
     * Breakpoint for "Mobile". This is used to help adjust the viewbox
     * in the main SVG file because CSS can't reach it.
     *
     * @type {Number}
     */
    public static MOBILE_WIDTH: number = 768;

    /**
     * Breakpoint for "Phone". This is used to help adjust the viewbox
     * in the main SVG file because CSS can't reach it.
     *
     * @type {Number}
     */
    public static PHONE_WIDTH: number = 480;

    /**
     * Name of the popular social network: Instagram
     *
     * @type {String}
     */
    public static SOCIAL_INSTAGRAM: string = "Instagram";

    /**
     * Name of the popular social network: Facebook
     *
     * @type {String}
     */
    public static SOCIAL_FACEBOOK: string = "Facebook";

    /**
     * Name of the popular social network: Twitter
     *
     * @type {String}
     */
    public static SOCIAL_TWITTER: string = "Twitter";

    /**
     * Show controls state
     *
     * @type {String}
     */
    public static STATE_SHOW_CONTROLS: string = "show-controls";

    /**
     * Application state to show the experience once it has loaded
     *
     * @type {String}
     */
    public static STATE_SHOW_EXPERIENCE: string = "show-experience";

    /**
     * Breakpoint for "Tablet". This is used to help adjust the viewbox
     * in the main SVG file because CSS can't reach it.
     *
     * @type {Number}
     */
    public static TABLET_WIDTH: number = 768;

    /**
     * Public window key the birthday sits on
     *
     * @type {String}
     */
    public static WINDOW_KEY_BIRTHDAY: string = "nao_birthday";

    /**
     * Public window key the zodiac sits on
     *
     * @type {String}
     */
    public static WINDOW_KEY_ZODIAC: string = "nao_astrologicalSign";

}
